<div [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'"
(click)="windowClick()">
  <dialog-header [label]="'SETTINGS.POINTS_SETTINGS' | translate" [dialogRef]='dialogRef' [object]='this'></dialog-header>
  <mat-card class="display-settings">
    <mat-selection-list dense>
      <mat-list-option class="selection-list-option" checkboxPosition="before"
        *ngFor="let pointElem of pointElements; index as i" [selected]="pointElementsOn[i]"
        (click)="onPointElemBtnClick(i)">{{pointElem}}</mat-list-option>
    </mat-selection-list>
  </mat-card>
</div>